import { Box, Flex, FlexProps, Text, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import BlockContent from '@sanity/block-content-to-react';
import { rgba } from 'polished';
import React, { FC } from 'react';
import { rem } from 'utils/fonts';
interface Props {
  image: string;
  title: string;
  description: SanityRichText[];
}

const Wrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  min-height: 390px;
  border-radius: 9px;
  padding: 20px;
`;

const ImageWrapper = styled(Flex)<{ image: string }>`
  width: 100%;
  height: 165px;
  background-image: url(${(props): string => (props.image ? props.image : '')});
  background-size: cover;
  border-radius: 6px;
  margin-bottom: 20px;
`;

const StyledHeader = styled(Text)`
  font-size: ${rem(20)};
  line-height: 23px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const StyledDescription = styled(Box)`
  font-size: ${rem(14)};
  line-height: 135%;
  font-weight: 500;
`;

const ExpandedGoalSlide: FC<Props & FlexProps> = ({ image, title, description }, props) => {
  const { colors } = useTheme();
  return (
    <Wrapper bg="white" {...props}>
      <ImageWrapper image={image} />
      <StyledHeader color="gray.900" fontFamily="heading">
        {title}
      </StyledHeader>
      <StyledDescription color={rgba(colors.gray[900], 0.5)}>
        <BlockContent blocks={description} />
      </StyledDescription>
    </Wrapper>
  );
};

export default ExpandedGoalSlide;
